module.exports = __webpack_public_path__ + "img/img-3.810a9b97.jpg";